import { render, staticRenderFns } from "./StockCardSectionControl.vue?vue&type=template&id=4a3cd242&scoped=true&"
import script from "./StockCardSectionControl.vue?vue&type=script&lang=js&"
export * from "./StockCardSectionControl.vue?vue&type=script&lang=js&"
import style0 from "./StockCardSectionControl.vue?vue&type=style&index=0&id=4a3cd242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3cd242",
  null
  
)

export default component.exports
import {QTabs,QTab,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QTabs,QTab,QInnerLoading,QSpinnerGears}, component.options.components || {})
